var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-container',{attrs:{"fluid":""}},[(_vm.loading)?[_c('v-progress-linear',{attrs:{"height":"5","indeterminate":true}})]:[_c('app-campus-info',{attrs:{"campus":_vm.campus,"loading":_vm.loading}}),_c('br')]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }